import React, { useReducer, useContext } from "react";
import axios from "axios";
import TrackingContext from "./TrackingContext";
import TrackingReducer from "./TrackingReducer";
import {
  SET_LOADING,
  GET_TRACKING,
  GET_TRACKING_ERROR,
  FULFILL_ORDER_PROGRESS,
  FULFILL_ORDER,
} from "../types";
import AuthContext from "../auth/AuthContext";

const DashboardState = (props) => {
  const initialState = {
    loading: false,
    tracking: null,
    returnedData: null,
    fulfillProgress: null,
    error: null,
  };

  const [state, dispatch] = useReducer(TrackingReducer, initialState);
  const { user } = useContext(AuthContext);

  // Set Loading
  const setLoading = () =>
    dispatch({
      type: SET_LOADING,
    });

  // Get Tracking Records
  const getTracking = async (tracking_list) => {
    setLoading(true);
    try {
      let numLoop = Math.ceil(tracking_list.length / 300);
      let tracking_list_sliced = [];
      let returned = [];

      // Pass order ID list 10 by 10 to the backend until all data processed
      for (let x = 0; x < numLoop; x++) {
        let store_name_list = [];
        let name_list = [];
        let start = x * 300;
        let end = (x + 1) * 300;
        tracking_list_sliced = tracking_list.slice(start, end);

        tracking_list_sliced.forEach((list) => {
          store_name_list.push(list.store_name);
          name_list.push(list.name);
        });

        const res = await axios.post("/api/tracking/get-tracking", {
          tracking_list: tracking_list_sliced,
          store_name_list: store_name_list,
          name_list: name_list,
        });
        returned = returned.concat(res.data.tracking);

        dispatch({
          type: FULFILL_ORDER_PROGRESS,
          payload: (
            (parseFloat(start + tracking_list_sliced.length) /
              tracking_list.length) *
            100
          ).toFixed(2),
        });
      }
      dispatch({
        type: GET_TRACKING,
        payload: returned,
      });
    } catch (err) {
      dispatch({
        type: GET_TRACKING_ERROR,
        payload: err.response.statusText,
      });
    }
  };

  // Fulfill Order
  const fulfillOrder = async (tracking_list) => {
    setLoading(true);
    try {
      let track_list = [];
      let existed = [];

      await axios.post("/api/tracking/upload-trigger-log", {
        username: user.name,
      });

      // Group tracking_list by store_name and name
      tracking_list.forEach((tList) => {
        if (tList.fulfillment_status !== "fulfilled") {
          if (!existed.includes(tList.store_name + " " + tList.order_id)) {
            existed.push(tList.store_name + " " + tList.order_id);
            track_list.push({
              store_name: tList.store_name,
              name: tList.order_id,
              financial_status: tList.financial_status,
              fulfillment_status: tList.fulfillment_status,
              gateway: tList.gateway,
              id: tList.id,
              line_items: tList.line_items,
              refunds: tList.refunds,
              transaction_id: tList.transaction_id,
              tracking_items: [
                {
                  sku: tList.sku,
                  quantity: tList.quantity,
                  tracking_id: tList.tracking_id,
                },
              ],
            });
          } else {
            track_list.forEach((list) => {
              if (
                list.store_name === tList.store_name &&
                list.name === tList.order_id
              ) {
                list.tracking_items.push({
                  sku: tList.sku,
                  quantity: tList.quantity,
                  tracking_id: tList.tracking_id,
                });
              }
            });
          }
        }
      });

      let numLoop = Math.ceil(track_list.length / 10);
      let tracking_list_sliced = [];
      let returned = [];

      // Pass order ID list 10 by 10 to the backend until all data processed
      for (let x = 0; x < numLoop; x++) {
        let start = x * 10;
        let end = (x + 1) * 10;
        tracking_list_sliced = track_list.slice(start, end);
        const res = await axios.post("/api/tracking/fulfill-order", {
          tracking_list: tracking_list_sliced,
          range: start + 1 + " - " + (start + tracking_list_sliced.length),
        });
        returned = returned.concat(res.data.returnedData);

        dispatch({
          type: FULFILL_ORDER_PROGRESS,
          payload: (
            (parseFloat(start + tracking_list_sliced.length) /
              track_list.length) *
            100
          ).toFixed(2),
        });
      }

      dispatch({
        type: FULFILL_ORDER,
        payload: returned,
      });
    } catch (err) {
      dispatch({
        type: GET_TRACKING_ERROR,
        payload: err.response,
      });
    }
  };

  return (
    <TrackingContext.Provider
      value={{
        loading: state.loading,
        tracking: state.tracking,
        returnedData: state.returnedData,
        fulfillProgress: state.fulfillProgress,
        error: state.error,
        setLoading,
        getTracking,
        fulfillOrder,
      }}
    >
      {props.children}{" "}
    </TrackingContext.Provider>
  );
};

export default DashboardState;
